import {useQuery} from 'react-query'
import {ManagerEditModalForm} from './ManagerEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getManagersFilter} from '../core/_requests'
import {ManagerStatus} from '../core/_models'
import {useAuth} from '../../../../auth/core/Auth'

const ManagerEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {currentUser} = useAuth()

  const {
    isLoading,
    data: manager,
    error,
    status
  } = useQuery(
    `${QUERIES.MANAGERS_LIST}-manager-${itemIdForUpdate}`,
    () => {
      return getManagersFilter(currentUser?.last_company_id, {id: itemIdForUpdate, take: 0, skip: 1})
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return (
      <ManagerEditModalForm
        isManagerLoading={isLoading}
        response={{
          status_id: ManagerStatus.active.id,
          created_at: new Date(),
        }}
        status={status}
      />
    )
  }

  if (!isLoading && !error && manager) {
    return (
      <ManagerEditModalForm
      isManagerLoading={isLoading}
        response={manager?.data}
        status={status}
      />
    )
  }

  return null
}

export {ManagerEditModalFormWrapper}
